import Http from '../Http';

const baseUrl = `${process.env.VAPI_BASE_URL}/currency`;

export default {
  list: (data, options) => Http.post(`${baseUrl}/supported`, data, options),
};
